<template>
  <div class="contents header-padding">
    <div class="container">
      <h2>店舗一覧</h2>

      <ul class="shop-list">
        <li v-for="(shop, index) in shops" :key="index" class="shop">
          <h3>{{ shop.label }}</h3>
          <div class="detail">
            <div class="image"><img v-if="shop.src" :src="shop.src" :alt="shop.label"></div>
            <div class="texts">
              <p v-if="shop.tel" class="tel"><a :href="`tel:${shop.tel}`">{{ shop.tel }}</a></p>
              <p v-if="shop.hours" class="hours">{{ shop.hours }}</p>
              <div v-if="shop.zip || shop.address" class="addresses">
                <p v-if="shop.zip" class="zip">{{ shop.zip }}</p>
                <p v-if="shop.address" class="address">{{ shop.address }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <p class="toTop"><a href="/">トップページへ戻る</a></p>
  </div>
</template>

<script>
export default {
  name: 'Shop',
  data() {
    return {
      shops: [
        // 退店に伴い落とし
        // {
        //   label: 'JAPAN EDITION 原宿',
        //   zip: '〒150-0001',
        //   address: '東京都渋谷区神宮前4-27-2 1-2F',
        //   tel: '03-6804-5422',
        //   hours: '12:00-20:00',
        //   src: '/img/shops/S__42090810.jpg',
        // },
        {
          label: 'JAPAN EDITION 銀座',
          zip: '〒104-0061',
          address: '東京都中央区銀座2-3-5',
          tel: '03-5915-4215',
          hours: '12:00-20:00',
          src: '/img/shops/ginza.jpg',
        },
        {
          label: 'JAPAN EDITION 新宿',
          zip: '〒160-0022',
          address: '東京都新宿区新宿3-37-1 フラッグス2F',
          tel: '03-5315-0607',
          hours: '11:00-21:00',
          src: '/img/shops/shinjuku.jpg',
        },
        {
          label: 'JAPAN EDITION 京都',
          zip: '〒604-8086',
          address: ' 京都府京都市中京区御幸町通六角下ル伊勢屋町350',
          tel: '075-585-2799',
          hours: '11:00-20:00',
          src: '/img/shops/S__42090809.jpg',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
h2 {
  font-size: 1.6em;
  font-weight: normal;
}

h3 {
  font-size: 1.2em;
  font-weight: normal;
  margin-bottom: .5em;
}

.shop-list {
  margin-top: 3.5em;
  li {
    .detail {
      display: flex;
    }
    .image {
      width: 70%;
      margin-right: 10px;
    }
    .texts {
      width: 30%;
    }
    .tel {
      margin-bottom: 1em;
      a {
        letter-spacing: 0;
        display: block;
        font-size: 1em;
        font-weight: bold;
        color: #4FBCE7;
        text-decoration: underline;
      }
    }
    .hours {
      margin-bottom: 1em;
    }
    .addresses {
      font-size: .8em;
      .zip {
      }
      .address {
      }
    }
    &:not(:first-child) {
      margin-top: 2em;
    }
  }
}

@media screen and (min-width: 576px) {
  $mgn: 10px;
  .shop-list {
    display: flex;
    flex-wrap: wrap;
    li {
      width: calc(100% / 2 - $mgn);
      .detail {
        display: block;
        .image, .texts {
          width: 100%;
        }
        .image {
          margin-bottom: .5em;
        }
      }
      &:not(:first-child) {
        margin-top: 0;
      }
      &:nth-child(even) {
        margin-left: $mgn;
      }
      &:nth-child(n + 3) {
        margin-top: ($mgn * 3);
      }
    }
  }
}

@media screen and (min-width: 768px) {
  $mgn: 10px;
  .shop-list {
    li {
      width: calc(100% / 3 - ($mgn * 2));
      &:nth-child(even) {
        margin-left: 0;
      }
      &:nth-child(n + 3) {
        margin-top: 0;
      }
      &:nth-child(n + 4) {
        margin-top: ($mgn * 3);
      }
      &:not(:nth-child(3n + 1)) {
        margin-left: $mgn;
      }
    }
  }
}


</style>
